import { courses } from "Constants/courses";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { classNames } from "Store/utils";
import trustEdgeStyles from "TrustEdge.module.css";
const addShakeAnimation = (parent_program_ids = []) => {
  if (!parent_program_ids || parent_program_ids?.length === 0) return;

  parent_program_ids?.forEach?.((parent_program_id) => {
    const parentProgram = document.querySelector(`#pc-${parent_program_id}`);

    if (parentProgram) {
      parentProgram.classList.add("shake");
    }
  });
};

const removeShakeAnimation = (parent_program_ids = []) => {
  if (!parent_program_ids || parent_program_ids?.length === 0) return;

  parent_program_ids?.forEach?.((parent_program_id) => {
    const parentProgram = document.querySelector(`#pc-${parent_program_id}`);

    if (parentProgram) {
      parentProgram.classList.remove("shake");
    }
  });
};

const CourseCard = ({
  id,
  course_img,
  course_title,
  program_start_date,
  duration,
  category,
  program_type,
  parent_program_ids = [],
}) => {
  const handleKnowMore = () => {
    if (category === "Individual Course - Registration Open" || category === "Individual Course - Registration Closed" || category === "Individual Course - Upcoming" || category === "Individual Course") {
      window.location.href = `/course/${id}`;
    } else {
      window.location.href = `/program/${id}`;
    }
  };

  let parent_program_title = null;
  if (parent_program_ids) {
    parent_program_title = parent_program_ids
      ?.map((parent_program_id) =>
        courses
          .find((c) => c.id === parent_program_id)
          ?.program_title?.replace("Professional Certification in", "")
      )
      .join(" & ");
  }

  const isProfessionalCertificate = category === "Professional Certificate";


  // Check if this is one of the upcoming courses starting May 04, 2026
  const isComingSoonCourse = (id === 3);
  const isRegistrationClosedCourse = (id === 8 || id === 5);
  const isAcceptingApplicationsCourse = (id === 7);


  return (
    <div
      className="course-cardd p-2 w-100"
      onClick={handleKnowMore}
      style={{
        cursor: "pointer",
        transition: "transform 0.3s, box-shadow 0.3s",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.05)";
        e.currentTarget.style.boxShadow =
          "0 0 40px -8px rgb(0 0 0 / 16%), 0 0 24px -16px rgb(0 0 0 / 16%)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "none";
      }}
      id={`pc-${id}`}
    >
      {isProfessionalCertificate && (
        <div className="ribbon">
          <span className={classNames(trustEdgeStyles["size14"], "trustedge_weight-600 px-2")} style={{ color: "white" }}>
            Program
          </span>
        </div>
      )}
      
      {isComingSoonCourse && (
        <div className="ongoing_ribbon" style={{ backgroundColor: "#ffb366" }}>
          <span className={classNames(trustEdgeStyles["size14"], "trustedge_weight-600 px-2")} style={{ color: "white" }}>
             Upcoming
          </span>
        </div>
      )}

      {isRegistrationClosedCourse && (
        <div className="ongoing_ribbon" style={{ backgroundColor: "#ffb366" }}>
          <span className={classNames(trustEdgeStyles["size14"], "trustedge_weight-600 px-2")} style={{ color: "white" }}>
            Registration Closed
          </span>
        </div>
      )}

      {isAcceptingApplicationsCourse && (
        <div className="ongoing_ribbon" style={{ backgroundColor: "#6f42c1" }}>
          <span className={classNames(trustEdgeStyles["size14"], "trustedge_weight-600 px-2")} style={{ color: "white" }}>
            Accepting Applications
          </span>
        </div>
      )}
      
      <Row className="m-0">
        <Col xs={12} className="p-2">
          <img
            className="w-100 course-img"
            src={course_img}
            style={{ height: "178px", objectFit: "cover" }}
            alt="Course"
          />
          {/* <span className="course-free">Free</span> */}
        </Col>
      </Row>
      <div
        className="m-0 p-2 d-flex flex-column justify-content-between"
        style={{ minHeight: "200px" }}
      >
        <Row className="m-0">
          <Col xs={12}>
            <p className={classNames(trustEdgeStyles['course-title'], "sizee20 mb-1")} style={{ height: "10px" }}>
              {course_title}
            </p>
          </Col>
        </Row>
        <div>
          <Row className="m-0">
            {category && (
              <Col md={12} xs={12}>
                <div
                  className="mx-0 mb-1 text-left"
                  style={{
                    background: "#e7eef8",
                    color: "black",
                    fontSize: "12px",
                    fontWeight: "600",
                    padding: "4px",
                    display: "inline-block",
                  }}
                >
                  {category}
                </div>
              </Col>
            )}
            <Col
              xs={6}
              className="d-flex justify-content-start mb-1"
              style={{ fontSize: "16px", color: "black" }}
            >
              <p className="mb-0">{duration}</p>
            </Col>
            {program_type && (
              <Col
                xs={6}
                className="d-flex justify-content-end mb-1"
                style={{ fontSize: "16px", color: "black" }}
              >
                <p className="mb-0">{program_type}</p>
              </Col>
            )}
          </Row>
          <Row className="m-0 d-flex align-items-center">
            <Col xs={7} sm={6} md={7}>
              <p
                className="mb-0"
                style={{ fontSize: "14px", color: "darkgrey", whiteSpace: "nowrap" }}
              >
                Starts: {program_start_date}
              </p>
            </Col>
            <Col xs={5} sm={6} md={5} className="d-flex justify-content-end">
              <button className="know-more" onClick={handleKnowMore}>
                Know More
              </button>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
